<template>
  <div class="home-flashsale xm-plain-box">
    <Head />
    <Content />
    <div class="home-banner-box">
      <a href="">
        <img src="../../../assets/imgs/home-banner.jpg" alt="test" width="1226" height="430">
      </a>
    </div>
  </div>
</template>

<script>
import Head from './Head'
import Content from './Content'

export default {
  name: 'XiaoMiSG',
  components: {
    Head,
    Content
  }
}
</script>

<style>
.home-flashsale {
  margin-bottom: 22px;
  position: relative;
}
.home-banner-box {
  /* height: 120px; */
  margin: 22px 0;
  overflow: hidden;
}
</style>